export default __webpack_public_path__ + "9783475925f7807494ae2a8229258f70.glb";